// extracted by mini-css-extract-plugin
module.exports = {"bottom-bar":"BottomBar_bottom-bar__3Y8CD","is-active":"BottomBar_is-active__39rOf"};